<script setup lang="ts">
import { createError, useRoute } from '#app';
import { toolCategoryBySlug } from '@/lib/tool-taxonomy';
import SeoLandingIndexPage from '../index.vue';

const route = useRoute();
const rawCategory = Array.isArray(route.params.category)
  ? route.params.category[0]
  : route.params.category;
const category = toolCategoryBySlug(rawCategory);

if (!category) {
  throw createError({ statusCode: 404, statusMessage: 'Tools category not found' });
}
</script>

<template>
  <SeoLandingIndexPage :category="category.value" />
</template>
